import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class ProgrammableLogicController_ds_get_tote_groupingsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: {  }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, PlcInstructions?: string, ToteContainerId?: number, ToteContainer?: { Id?: number, LookupCode?: string }, Type?: { Description?: string, Name?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_tote_groupings/get`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, PlcInstructions?: string, ToteContainerId?: number, ToteContainer?: { Id?: number, LookupCode?: string }, Type?: { Description?: string, Name?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_tote_groupings/getList`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { $keys: number[] }): 
  Promise<{ result: { Id?: number, ContainerTypeId?: number, PlcInstructions?: string, ToteContainerId?: number, ToteContainer?: { Id?: number, LookupCode?: string }, Type?: { Description?: string, Name?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/ProgrammableLogicController/datasources/ds_get_tote_groupings/getByKeys`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
